import { render, staticRenderFns } from "./ClimateOverlayModal.vue?vue&type=template&id=4a20eee8&"
import script from "./ClimateOverlayModal.vue?vue&type=script&lang=js&"
export * from "./ClimateOverlayModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports